import React from 'react';
import { Flex } from '@chakra-ui/react';
import { TextDisplay } from './TextDisplay';
import { TextEmptyState } from './TextEmptyState';
import { IFormFieldState } from '../../../FormFieldSet';
import SimpleFieldHeader from '../common/SimpleFieldHeader';
import { IFormFieldText } from '.';

interface ISimpleTextProps {
  formFieldState: IFormFieldState;
  config: IFormFieldText;
}

const SimpleText: React.FC<ISimpleTextProps> = ({ formFieldState }) => {
  return (
    <Flex flexDirection="column" gap={2}>
      <SimpleFieldHeader {...formFieldState} />
      {formFieldState.value ? (
        <TextDisplay
          textStyle={
            formFieldState.formFieldDefinition.name === 'Title'
              ? 'headingTitle'
              : 'textBody'
          }
          value={formFieldState.value as string}
        />
      ) : (
        <TextEmptyState />
      )}
    </Flex>
  );
};

export default SimpleText;
